// TOUR-13 — Knowledge Base browse + gap awareness (manager lane).

import type { FireflyTourArtifact } from "../tourTypes";

export const KNOWLEDGEBASE_TOUR_ID = "tour-knowledgebase";

export const KNOWLEDGEBASE_TOUR: FireflyTourArtifact = {
  id: KNOWLEDGEBASE_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "knowledge base tour",
    "knowledgebase tour",
    "find a policy",
    "search kb",
    "how do i search the knowledge base",
    "kb library tour",
    "knowledge gap inbox",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer", "admin"],
  steps: [
    {
      id: "nav-knowledgebase",
      target: {
        mode: "knowledgebase",
        anchorId: "mode-nav-knowledgebase",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "knowledgebase",
      copy: {
        title: "Open Knowledge Base",
        body: "Author and browse org KB articles here under Manager. Tap Knowledge Base in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "kb-workspace",
      target: { mode: "knowledgebase", anchorId: "kb-workspace", scrollIntoView: true },
      copy: {
        title: "KB workspace",
        body: "The workspace hub links Library search, the article Editor, Gap Inbox, and bulk import. Trainers draft; admins publish live changes.",
      },
      advanceOn: "next_button",
    },
    {
      id: "gap-inbox-tile",
      target: { mode: "knowledgebase", anchorId: "kb-gap-inbox-tile", scrollIntoView: true },
      copy: {
        title: "Gap Inbox",
        body: "Open items here when reps miss answers or AI drafting surfaces a gap. Authors with is_kb_author also see KB gaps inside Firefly.",
      },
      destructive: true,
    },
    {
      id: "library-tile",
      target: { mode: "knowledgebase", anchorId: "kb-library-tile", scrollIntoView: true },
      copy: {
        title: "Library",
        body: "Tap Library to search published and draft articles by title, slug, audience, scope, and status.",
      },
      waitForClick: true,
    },
    {
      id: "kb-search",
      target: { mode: "knowledgebase", anchorId: "kb-search", scrollIntoView: true },
      copy: {
        title: "Search the library",
        body: "Type a policy name or slug fragment, narrow filters if needed, then run Search library. Show drafts lists unpublished trainer proposals.",
      },
      advanceOn: "next_button",
    },
    {
      id: "kb-search-submit",
      target: { mode: "knowledgebase", anchorId: "kb-search-submit", scrollIntoView: true },
      copy: {
        title: "Run search",
        body: "Search library queries the org KB index. Results load in the list on the right — tap a row to open it in the Editor.",
      },
      waitForClick: true,
    },
    {
      id: "kb-results-list",
      target: { mode: "knowledgebase", anchorId: "kb-results-list", scrollIntoView: true },
      copy: {
        title: "Article results",
        body: "Select a row to load the article into the Editor. Published articles stay locked for trainers until an admin publishes changes.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "knowledgebase", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Reps consume KB answers from Training Ask, Ads Assistant, and voice surfaces — this mode is for authors. Ask Firefly anytime for Sales tours.",
      },
      advanceOn: "next_button",
    },
  ],
};
